import React from "react";
import RadioInput from "../../Components/RadioInput/RadioInput";
import Revenue from "../../Data/Revenue";
import RegistrationForm from "../../Components/RegistrationForm/RegistrationForm";
import jwt_decode from "jwt-decode";
import GooLoader from "../../Components/GooLoader/GooLoader";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./RevenueForm.css";

class RevenueForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      isLoading: true,
    };

    this.handleRadioOnChange = this.handleRadioOnChange.bind(this);
    this.handleMatchingCriteria3 = this.handleMatchingCriteria3.bind(this);
    this.handleBackButtonClick = this.handleBackButtonClick.bind(this);
  }

  componentDidMount() {
    let token = localStorage.getItem("token");
    if (!token) {
      this.props.history.push("/");
    } else {
      let decoded = jwt_decode(token);
      if (
        this.props.location.state === undefined ||
        !this.props.location.state.userData ||
        !this.props.location.state.userData.matching_criteria
      ) {
        if (!decoded.active) {
          this.props.history.push("/");
        } else {
          this.props.history.push("/dashboard");
        }
      } else {
        let userData = this.props.location.state.userData;
        if (!decoded.active) {
          this.props.history.push("/payment", { userData: userData });
        } else {
          const { industry_importance } = userData.matching_criteria;
          if (!industry_importance) {
            this.props.history.push("/matching-criteria-2", {
              userData: userData,
            });
          } else {
            if (this.props.matching_criteria_3 !== "") {
              this.setState({
                value: this.props.matching_criteria_3,
                isLoading: false,
              });
            } else {
              this.setState({
                isLoading: false,
              });
            }
          }
        }
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.value !== prevState.value && this.state.value !== "") {
      this.setState({
        showButton: true,
      });
    }
  }

  handleRadioOnChange(value) {
    this.props.setMatchingCriteria3(value);
    this.setState({
      value: value,
    });
  }

  handleMatchingCriteria3() {
    let min = this.state.value.min;
    let max = this.state.value.max;
    if ((min && max) || min === 0 || max === 0) {
      let userData = this.props.location.state.userData;
      this.props.history.push("/matching-criteria-4", {
        userData: {
          ...userData,
          matching_criteria: {
            ...userData.matching_criteria,
            revenue_range: {
              min: min,
              max: max,
            },
          },
        },
      });
    }
  }

  handleBackButtonClick() {
    this.props.history.goBack();
  }

  render() {
    return (
      <React.Fragment>
        {this.state.isLoading ? <GooLoader /> : null}

        <RegistrationForm
          containerClassName="container-matching-industry-3"
          hasCounter={true}
          step="3"
          hasQuote={true}
          quote="This is so we can have a benchmark for where you stand. This information won't be shared."
          headerText="Sounds good. About how much revenue does your business generate each year?"
          primaryButtonText="Next step"
          hasSkip={false}
          handlePrimaryBtnOnClick={this.handleMatchingCriteria3}
          activatePrimaryWithEnter={true}
          showButton={this.state.showButton}
          showBackButton={true}
          backButtonText="Back"
          handleBackButtonClick={this.handleBackButtonClick}
        >
          <Helmet>
            <title>Astronomic Network</title>
            <meta
              name="description"
              content="Austin entrepreneurs helping each other win"
            />
          </Helmet>

          <div className="form-container-body-row">
            <RadioInput
              name="revenue"
              data={Revenue}
              incomingValue={this.state.value}
              onChange={this.handleRadioOnChange}
            />
          </div>
        </RegistrationForm>
      </React.Fragment>
    );
  }
}

export default withRouter(RevenueForm);
